"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isQuoteProperty = exports.quotePropertyDefinition = void 0;
exports.quotePropertyDefinition = {
    view: {
        label: 'Blockquote',
        style: 'blockquote',
    },
    constraints: [
        {
            name: 'orderedProperties',
            argument: [
                'quote-text',
                'quote-author',
                'quote-link',
            ],
        },
    ],
    type: 'ordered-container',
    multiple: true,
    name: 'quote',
};
const isQuoteProperty = (prop) => {
    return prop.name === exports.quotePropertyDefinition.name;
};
exports.isQuoteProperty = isQuoteProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicXVvdGUucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9xdW90ZS5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLHVCQUF1QixHQUFHO0lBQ3JDLElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxZQUFZO1FBQ25CLEtBQUssRUFBRSxZQUFZO0tBQ3BCO0lBQ0QsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsbUJBQW1CO1lBQ3pCLFFBQVEsRUFBRTtnQkFDUixZQUFZO2dCQUNaLGNBQWM7Z0JBQ2QsWUFBWTthQUNiO1NBQ0Y7S0FDRjtJQUNELElBQUksRUFBRSxtQkFBbUI7SUFDekIsUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsT0FBTztDQUNrQixDQUFBO0FBSTFCLE1BQU0sZUFBZSxHQUFHLENBQUMsSUFBa0IsRUFBeUIsRUFBRTtJQUMzRSxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssK0JBQXVCLENBQUMsSUFBSSxDQUFBO0FBQ25ELENBQUMsQ0FBQTtBQUZZLFFBQUEsZUFBZSxtQkFFM0IifQ==